var path = 'msi/modals/header/header.html';
var html = "<div class=\"og-modal-header\">\n  <div class=\"og-modal-header-content\" ng-transclude></div>\n  <og-close-modal></og-close-modal>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;